module.exports = __webpack_public_path__ + "static/floral 5 3000x3000-86a51a2c81ed9361a0f4004522da3341.jpg";